import React, {Component} from 'react';
import Main from '../../components/smart/Main';
import FloatContainer from '../../components/dummy/FloatContainer';
import EmployersIcon from './../../Icons/EmployersIcon.png';
import FileIcon from  './../../Icons/FileIcon.png';
import ToothbrushIcon from  './../../Icons/ToothbrushIcon.png';
import BrokerZip from './../../utils/Forms/BrokerZip.zip';

class BrokersPage extends Component {
    
    render() {
        return(
                <Main
                Title="Why Quote Matrix Healthcare Dental & Vision?"
                Description=" "
                >
                    <FloatContainer>
                        <div className="Float_Content_3">
                            <div className="Float_Title">
                                <img src={EmployersIcon}alt="Commitment Icon"></img>
                                <h4>Empowering Employers</h4>
                            </div>
                            <p>• Matrix Healthcare grows from employers wanting to provide unique dental and vision plans to their employees.
                                <br></br>• We find win-win solutions for the employer, employees, and professional providers.
                                <br></br>• Our goal is to provide our clients with a more personalized experience, competitive pricing, excellent coverage, and simplified administration. 
                                <br></br>• We provide both self-funded and fully-insured dental plan options as well as a vision reimbursement plan.
                            </p>
                        </div>
                        <div className="Float_Content_3">
                            <div className="Float_Title">
                                <img src={FileIcon}alt="Commitment Icon"></img>
                                <h4>Making Dental Personal</h4>
                            </div>
                            <p>• Matrix Healthcare provides flexibility that allows our clients to offer uniquely designed benefit packages.
                                <br></br>• We can provide guidance on plan design options involving the most up-to-date dental procedures and guidelines.
                                <br></br>• Employers and their employees have direct access to their dedicated and knowledgeable account managers. 
                                <br></br>• Our experienced professionals assist with plan design questions, claim resolution, data collection, and reporting. 
                            </p>
                        </div>
                        <div className="Float_Content_3">
                            <div className="Float_Title">
                                <img src={ToothbrushIcon}alt="Commitment Icon"></img>
                                <h4>Our Network, Your Dentist</h4>
                            </div>
                            <p>• Our members have access to 2,700 dentists through the Cache Premier Dental Network, one of the largest dental networks in Utah. 
                            <br></br>• With our TPA partner BAS, Matrix Healthcare offers a nationwide provider network through DenteMax for groups with members residing or needing dental services outside of the Utah service area. 
                            <br></br> • We're committed to expanding our network to include your providers.
                               <br></br> • Don't forget our vision plan has no network, members can see any provider.
                            </p>
                        </div>
                    </FloatContainer>
                    <div>
                        <p>
                            At Matrix Healthcare we're committed to making the experience smooth and smiple. 
                            We have the experience to stay ahead of the curve and keep your clients feeling safe.
                            To provide the best experience we strive to be transparent and clear about each individual group.
                            Every step we take is focused on making insurance and benefits simpler for everyone in volved. 
                        </p>
                    </div>
                    <hr></hr>
                    <FloatContainer>
                        <div className="Float_Content_Centered">
                            <h4>Ready to Quote Matrix?</h4>
                            <ul style={{listStyleType: "none", padding: "0"}} >
                                <li>
                                <a href="/Quote" target="_blank" rel="noopener noreferrer">Quoting Requirements</a>
                                </li>
                                <li>
                                <a href={BrokerZip} target="_blank" rel="noopener noreferrer">Broker Appointment Forms</a>
                                </li>
                            </ul>
                        </div>
                        <div className="Float_Content_Centered">
                            <h4>Have Questions?</h4>
                            <p>Reach out to Trisha Germain at <a href="tel:(801)631-0857">(801)631-0857</a></p>
                        </div>
                        <div className="Float_Content_Centered">
                            <h4>Plans Available</h4>
                            <p>Dental PPO, Dental Copay, Vision Reimbursement</p>
                        </div>
                    </FloatContainer>
                </Main>
        )
    }
}

export default BrokersPage;